import { defineMessages } from 'react-intl';

export default defineMessages({
  successfullyEnabledRefundAssist: {
    description: 'notification message to display when the user successfully enables Refund Assist',
    defaultMessage: 'You have successfully enabled Refund Assist.',
    id: 'PFD4Fb',
  },
  successfullyDisabledRefundAssist: {
    description: 'notification message to display when the user successfully disables Refund Assist',
    defaultMessage: 'You have successfully disabled Refund Assist.',
    id: 'uuDVQi',
  },
  failedToSave: {
    description: 'notification message to display if there are any issues saving the Refund Assist settings',
    defaultMessage: 'Failed to save configuration, please try again',
    id: 'c88gpc',
  },
  refundAssistTitle: {
    description: 'title for the Refund Assist Settings page',
    defaultMessage: 'Refund Assist',
    id: 'oyhf5V',
  },
  refundAssistDescription: {
    description: 'brief description of what happens when Refund Assist is enabled',
    defaultMessage:
      'With Refund Assist, ShipStation identifies which of your unused USPS labels are eligible for a refund and submits a refund request on your behalf.',
    id: 'RxvYHr',
  },
  howDoesRefundAssistWork: {
    description: 'description for how Refund Assist works',
    defaultMessage:
      '<b>How does Refund Assist work?</b> When enabled, Refund Assist monitors your orders and provides automated assistance for processing refunds based on your configured business rules.',
    id: 'eiGD3j',
  },
  learnMore: {
    description: 'link to the help center article for Refund Assist',
    defaultMessage: 'Learn more',
    id: 'htmrfY',
  },
  learnMoreAboutRefundAssist: {
    description: 'external link text for learning more about Refund Assist',
    defaultMessage: 'Learn more about Refund Assist',
    id: 'lP66Gx',
  },
  upgradeBannerTitle: {
    description: 'message for the upgrade banner about Refund Assist',
    defaultMessage: 'Never miss a refund for unused USPS labels!',
    id: 'ySSD98',
  },
  upgradeBannerMessage: {
    description: 'message for the upgrade banner about Refund Assist',
    defaultMessage:
      'You can authorize ShipStation to submit USPS label refunds on your behalf. Enable this feature for each of your USPS accounts.',
    id: '21f6UY',
  },
  enableRefundAssistLabel: {
    description: 'label for the Refund Assist enabled toggle',
    defaultMessage: 'Enable Refund Assist',
    id: 'ZG3b/r',
  },
  disclaimerAuthorization: {
    description: 'refund assist disclaimer text about authorization',
    defaultMessage:
      'You have authorized ShipStation to review unused, trackable USPS® labels, to identify which labels are eligible for a refund, and to submit refund requests to USPS on your behalf.',
    id: 'KYUYJB',
  },
  disclaimerReview: {
    description: 'refund assist disclaimer text about the review process',
    defaultMessage:
      'The review includes USPS labels that have not entered the mail stream within 21 days of the label print date. You can view eligible labels on the Shipments > Refund Assist page at any time. Once a refund request has been scheduled for a label, you have five days to exclude any labels you do not want refunded through Refund Assist.',
    id: '6FcyuJ',
  },
  disclaimerSubmission: {
    description: 'refund assist disclaimer text about submission process',
    defaultMessage:
      "ShipStation will then submit the refund request for the eligible labels to USPS on your behalf. USPS reviews the request within about 1-4 weeks. You'll then receive a credit to your account balance for 70% of the USPS-approved refund amount.",
    id: 'i7jDeX',
  },
  disclaimerViewCredit: {
    description: 'refund assist disclaimer text about viewing credits',
    defaultMessage:
      'To view the credited amount for any specific label, go to the Shipments > Refund Assist page and open the Shipment Details.',
    id: 'Zlnauj',
  },
  readMore: {
    description: 'button text to expand the disclaimer content',
    defaultMessage: 'Read more',
    id: 'avPiK/',
  },
  readLess: {
    description: 'button text to collapse the disclaimer content',
    defaultMessage: 'Read less',
    id: 'BSTW3C',
  },
  uspsDisclaimerTitle: {
    description: 'title for the USPS fraud disclaimer section',
    defaultMessage: 'USPS Fraud Disclaimer',
    id: 'x7ygGE',
  },
  uspsDisclaimerContentParagraph1: {
    description: 'content for the USPS fraud disclaimer',
    defaultMessage:
      'The filing of false, fictitious, or fraudulent refund requests may be punishable under the criminal laws of the United States. 18 U.S.C. §1001.',
    id: 'lW/Tt7',
  },
  uspsDisclaimerContentParagraph2: {
    description: 'content for the USPS fraud disclaimer',
    defaultMessage:
      'By opting into Refund Assist, you certify that the labels submitted for refund were unused and have been destroyed. You will be charged the cost of postage and a penalty for any refunded labels that are found to be used.',
    id: 'VLZdVN',
  },
  disableModalTitle: {
    description: 'title for the disable Refund Assist confirmation modal',
    defaultMessage: 'Disable Refund Assist',
    id: 'BnVlEA',
  },
  disableModalContentHeading: {
    description: 'content explaining what happens when disabling Refund Assist',
    defaultMessage: 'When you disable Refund Assist:',
    id: '7yRHwJ',
  },
  disableModalContentParagraph1: {
    description: 'content explaining what happens when disabling Refund Assist',
    defaultMessage: 'Labels already submitted for a refund will be reviewed by USPS and approved refunds applied to your account.',
    id: '1Lvwsy',
  },
  disableModalContentParagraph2: {
    description: 'content explaining what happens when disabling Refund Assist',
    defaultMessage: 'Labels currently scheduled for a refund request will not be submitted.',
    id: 'S0VIgJ',
  },
  disableModalContentFooter: {
    description: 'content explaining what happens when disabling Refund Assist',
    defaultMessage:
      'You can re-enable Refund Assist at any time. However, labels that are expired (31 days or older) at that time will not be eligible for Refund Assist.',
    id: 'NEmulr',
  },
  disableModalCancel: {
    description: 'cancel button text for the disable modal',
    defaultMessage: 'Cancel',
    id: 'ezOAz8',
  },
  disableModalConfirm: {
    description: 'confirm disable button text for the disable modal',
    defaultMessage: 'Disable',
    id: '0dUDmW',
  },
});
